export default class CreateSpaceCtrl {
  constructor ($scope, $timeout, $mdDialog, $stateParams, WorkPlanSrv, WorkPlanModalSrv, $cookies, GlobalConfig) {
    var createSpaceVm = this
    const texts = GlobalConfig.appTexts
    const currentUser = JSON.parse($cookies.get('currentUser'))
    let post = {
      workplanId: currentUser.workplanId,
      teacherId: currentUser.teacherId
    }

    // VARIABLES
    createSpaceVm.isEditing = !!($stateParams.workplanTeacherActivityId)
    createSpaceVm.rangeType = GlobalConfig.periods.rangeType
    createSpaceVm.workplanTeacherActivityId = null
    createSpaceVm.createOrEdit = 'Crear'
    createSpaceVm.textCreateOrEdit = texts.saved
    createSpaceVm.createOrEditMV = texts.createDialog
    createSpaceVm.typePeriod = []
    createSpaceVm.periodsArray = []
    createSpaceVm.selectedTypePeriod = {}
    createSpaceVm.isTouchedPeriods = false
    createSpaceVm.invalidCity = false
    createSpaceVm.startDate = null
    createSpaceVm.endDate = null
    createSpaceVm.minStartDate = moment().toDate()
    createSpaceVm.minEndDate = new Date()
    createSpaceVm.listEntity = []
    createSpaceVm.isSaveButtonDisabled = false
    createSpaceVm.isFeedback = currentUser.isFeedback
    createSpaceVm.dt_start = $cookies.get('wp_start')
    createSpaceVm.dt_end = $cookies.get('wp_end')

    // METHODS
    createSpaceVm.hasError = hasError
    createSpaceVm.showErrorMessages = showErrorMessages
    createSpaceVm.addSpace = addSpace
    createSpaceVm.validateForm = validateForm
    createSpaceVm.validateCheklistPeriods = validateCheklistPeriods
    createSpaceVm.funSelectedPeriod = funSelectedPeriod
    createSpaceVm.startDateChange = startDateChange
    createSpaceVm.confirmSpaceAction = confirmSpaceAction
    // createSpaceVm.searchCountry = searchCountry
    // createSpaceVm.changeCountry = changeCountry
    createSpaceVm.searchCity = searchCity
    createSpaceVm.changeCity = changeCity
    createSpaceVm.searchEntity = searchEntity
    createSpaceVm.changeEntity = changeEntity
    createSpaceVm.addOrEditSpaces = addOrEditSpaces
    createSpaceVm.close = close
    createSpaceVm.cleanRangeType = cleanRangeType
    createSpaceVm.availableCities = []
    createSpaceVm.enableCities = (country) => {
      createSpaceVm.countrySelected = false
      createSpaceVm.availableCities = createSpaceVm.cities.filter(city => city.codeCountry === country)
    }
    createSpaceVm.countrySelected = true

    createSpaceVm.updateRangeType = (val) => {
      createSpaceVm.rangeType = val
      createSpaceVm.periodsArray = []
      createSpaceVm.startDate = null
      createSpaceVm.endDate = null
    }
    createSpaceVm.updateRangeData = (val) => {
      createSpaceVm.periodsArray = val['periods']
      createSpaceVm.startDate = val['dates'][0]
      createSpaceVm.endDate = val['dates'][1]
    }

    activate()

    function activate () {
      WorkPlanSrv.getListSpacesCollaboration.getList(post).$promise.then(
        dataReturn => {
          if (dataReturn.status) {
            loadData(dataReturn)
            if (createSpaceVm.isEditing) {
              createSpaceVm.workplanTeacherActivityId = $stateParams.workplanTeacherActivityId
              createSpaceVm.activityId = GlobalConfig.minorActivityId.space
              createSpaceVm.createOrEdit = 'Editar'
              createSpaceVm.createOrEditMV = texts.editDialog
              createSpaceVm.textCreateOrEdit = texts.modified
              getDataSpaces()
            }
          } else {
            console.log('Comunications problem')
          }
        },
        data => {
          console.log(data)
        }
      )
    }

    function loadData (data) {
      createSpaceVm.listAmbit = data.listAmbitColaboration.items
      createSpaceVm.listTypePaticipate = data.listFormatColaboration.items
      createSpaceVm.listTypeComunity = data.listTypeColaboration.items
      createSpaceVm.listEntity = data.listsEntity.items
      createSpaceVm.cities = data.cities
      createSpaceVm.state = data.states
      createSpaceVm.countries = data.countries
      createSpaceVm.typePeriod = data.listPeriods.fulfillmentValue
    }

    function hasError (input) {
      if (input && input.$invalid && (input.$dirty || input.$touched)) {
        return 'has-error'
      }
    }

    function showErrorMessages (input) {
      return input && (input.$dirty || input.$touched)
    }

    function addSpace (isExecution) {
      let origin = GlobalConfig.activityTypeId.originActivityPlanning
      if (isExecution) {
        origin = GlobalConfig.activityTypeId.originActivityExecution
      }
      createJson(origin)
    }

    function validateForm (form) {
      return form.$invalid || createSpaceVm.validateCheklistPeriods()
    }

    function getDataSpaces () {
      let post = {
        workplanTeacherActivityId: parseInt(createSpaceVm.workplanTeacherActivityId),
        activityId: parseInt(createSpaceVm.activityId)
      }
      WorkPlanSrv.getSpacesCollaboration.get(post).$promise.then(function (dataReturn) {
        if (dataReturn.status) {
          setValues(dataReturn.project[0])
        } else {
          console.log('Comunications problem with the server')
        }
      }, function (data) {

      })
    }

    function setValues (space) {
      createSpaceVm.title = space.nameSpace
      createSpaceVm.description = space.description
      createSpaceVm.plannedHours = space.hoursPlanning
      createSpaceVm.typeComunity = space.typeSpaceId
      createSpaceVm.ambit = space.ambitColaborationId
      createSpaceVm.idEntity = space.entityId
      createSpaceVm.results = space.results
      createSpaceVm.link = space.link
      createSpaceVm.typeParticipate = space.typeParticipationId
      createSpaceVm.selectedItemEntity = space.entityName
      createSpaceVm.city = space.cityId
      createSpaceVm.selectedItemCity = null

      if (space.cityId && space.cityName) {
        createSpaceVm.selectedItemCity = {
          codeCity: space.cityId,
          codeState: space.cityState,
          nameCity: space.cityName
        }
      }

      createSpaceVm.rangeType = space.timeRangeTypeId
      createSpaceVm.country = space.countryId
      let m = moment(space.startDate, 'YYYY-MM-DD')
      createSpaceVm.dt_start = m.isValid() ? m.toDate() : null

      m = moment(space.endDate, 'YYYY-MM-DD')
      createSpaceVm.dt_end = m.isValid() ? m.toDate() : null

      if (createSpaceVm.rangeType === GlobalConfig.periods.rangeType) {
        createSpaceVm.periodsArray = space.periodId.split(',').map(id => {
          //createSpaceVm.selectedTypePeriod[Number(id)] = true
          return Number(id)
        })
      }

      if (space.isNotification == 0) {
        createSpaceVm.isNotification = false
      } else {
        createSpaceVm.isNotification = true
      }

      if (space.startDate) {
        var startDateNew = moment(space.startDate, 'YYYY-MM-DD').toDate()
        if (startDateNew <= moment().toDate()) {
          createSpaceVm.minStartDate = moment(space.startDate, 'YYYY-MM-DD').toDate()
        }
        startDateChange()
      }

      createSpaceVm.isEditing = true
    }

    function confirmSpaceAction () {
      let header = {
        createOrEdit: createSpaceVm.createOrEditMV,
        textCreateOrEdit: createSpaceVm.textCreateOrEdit,
        itemName: createSpaceVm.title,
        nameModal: texts.modalTypeName.collaborationSpace,
        modalType: texts.modalTypeId.collaborationSpace
      }
      WorkPlanModalSrv.setVariableSuccessDialog(header)
      WorkPlanModalSrv.successDialog(header).then((promise) => { })
    }

    function validateCheklistPeriods () {
      return (Number(createSpaceVm.rangeType) === 1 ? createSpaceVm.periodsArray.length < 1 : false)
    }

    function funSelectedPeriod (period, checked) {
      if (checked) {
        if (!createSpaceVm.periodsArray.includes(period.periodId)) {
          createSpaceVm.periodsArray.push(period.periodId)
        }
      } else {
        let index = createSpaceVm.periodsArray.indexOf(period.periodId)
        if (index != -1) {
          createSpaceVm.periodsArray.splice(index, 1)
        }
      }
      createSpaceVm.isTouchedPeriods = true
    }

    function startDateChange () {
      let m = moment(createSpaceVm.startDate)
      createSpaceVm.minEndDate = m.isValid() ? m/*.add(1, 'days')*/.toDate() : null
    }

    function searchEntity (searchText) {
      let matcher = new RegExp(searchText, 'i')
      let arr = []
      let attr = 'listItemName'
      createSpaceVm.listEntity.forEach((searchText) => {
        if (searchText[attr] && searchText[attr].match(matcher)) {
          arr.push(searchText)
        }
      })
      console.log(arr)
      return arr
    }

    function searchCity (searchText) {
      let matcher = new RegExp(searchText, 'i')
      let arr = []
      let attr = 'nameCity'
      createSpaceVm.availableCities.forEach((searchText) => {
        if (searchText[attr] && searchText[attr].match(matcher)) {
          if (searchText[attr] !== 'NO REGISTRA') arr.push(searchText)
        }
      })
      return arr
    }

    function changeCity (city) {
      if (city) {
        createSpaceVm.city = city.codeCity
        createSpaceVm.nameCity = city.nameCity
        for (var i = createSpaceVm.state.length - 1; i >= 0; i--) {
          if (createSpaceVm.state[i].codeState == city.codeState) {
            createSpaceVm.country = createSpaceVm.state[i].codeCountry
          }
        }
        createSpaceVm.invalidCity = false
      } else {
        createSpaceVm.city = null
        createSpaceVm.nameCity = ''
        createSpaceVm.country = null
        createSpaceVm.invalidCity = true
      }
    }

    function changeEntity (entity) {
      createSpaceVm.idEntity = entity.idListItem
      createSpaceVm.nameEntity = entity.listItemName
    }

    function createJson (origin) {
      var space = {
        teacherId: post.teacherId,
        workplanId: post.workplanId,
        activityId: GlobalConfig.minorActivityId.space,
        name: createSpaceVm.title,
        description: createSpaceVm.description,
        hoursPlanning: createSpaceVm.plannedHours,
        typeColaborationId: createSpaceVm.typeComunity,
        ambitColaborationParticipationId: createSpaceVm.typeParticipate,
        entityId: createSpaceVm.idEntity,
        results: createSpaceVm.results,
        link: createSpaceVm.link,
        ambitColaborationId: createSpaceVm.ambit,
        entityName: createSpaceVm.nameEntity,
        cityId: parseInt(createSpaceVm.city),
        timeRangeTypeId: createSpaceVm.rangeType,
        origin: origin,
        cityName: createSpaceVm.nameCity,
        isNotification: createSpaceVm.isNotification,
        isFeedbackActivity: createSpaceVm.isFeedback
      }
      if (createSpaceVm.isEditing) { space.workplanTeacherActivityId = parseInt(createSpaceVm.workplanTeacherActivityId) }

      if (parseInt(createSpaceVm.rangeType) === GlobalConfig.periods.rangeType) {
        var arrayPeriod = []
        for (var index in createSpaceVm.periodsArray) {
          var temp = {
            periodId: createSpaceVm.periodsArray[index]
          }
          arrayPeriod.push(temp)
        }
        space.periods = arrayPeriod
      } else {
        space.startDate = createSpaceVm.startDate
        space.endDate = createSpaceVm.endDate
      }
      addOrEditSpaces(space)
    }

    function addOrEditSpaces (space) {
      createSpaceVm.isSaveButtonDisabled = true

      WorkPlanSrv.addSpaceCollaboration.save(space).$promise.then(function (dataReturn) {
        if (dataReturn.status) {
          confirmSpaceAction()
        } else {
          createSpaceVm.isSaveButtonDisabled = false
          console.log('Error Comunications')
        }
      }, function (data) {
        createSpaceVm.isSaveButtonDisabled = false
        console.log(data)
      })
    }

    function close () {
      return $mdDialog.hide()
    }

    function cleanRangeType () {
      if (parseInt(createSpaceVm.rangeType) == GlobalConfig.periods.rangeType) {
        createSpaceVm.startDate = null
        createSpaceVm.endDate = null
      } else {
        createSpaceVm.selectedTypePeriod = []
        createSpaceVm.periodsArray = []
      }
    }
  }// FIN DEL CONSTRUCTOR

  preventInput (event) {
    var vKey = 86
    if (event.keyCode == vKey) { event.preventDefault() }
  }
}

CreateSpaceCtrl.$inject = ['$scope', '$timeout', '$mdDialog', '$stateParams', 'WorkPlanSrv', 'WorkPlanModalSrv', '$cookies', 'GlobalConfig']



// WEBPACK FOOTER //
// ./src/app/u-faculty/workplan/research/collaborationSpaces/createSpace/createSpaceCtrl.js